import { createTheme } from '@mui/material';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#28282B',
      paper: '#1C1C1E',
    },
    text: {
      primary: '#FFFFFF',
    },
    primary: {
      main: '#FFD700', // Gold for your buttons and highlights
    },
  },
});

export default darkTheme;
